import { Component, Input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ThemeService } from '../../themes/theme.service';

export interface ProgressRingItem {
  label:     string;
  pct:       number;       // 0 – 100+
  sublabel?: string;       // ej. "42 / 50 aprobados"
}

export interface DarkProgressRingConfig {
  title?:      string;
  headerIcon?: string;
  cols?:       2 | 3 | 4;  // columnas del grid (default 3)
  items:       ProgressRingItem[];
}

const R          = 26;                              // radio del anillo
const CIRC       = +(2 * Math.PI * R).toFixed(2);  // ≈ 163.36

@Component({
  selector: 'app-dark-progress-ring-card',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './dark-progress-ring-card.component.html',
  styleUrl:    './dark-progress-ring-card.component.scss',
})
export class DarkProgressRingCardComponent {
  @Input() config!: DarkProgressRingConfig;

  private readonly themeSvc = inject(ThemeService);

  get cols(): number { return this.config?.cols ?? 3; }

  circumference = CIRC;

  /** Offset del stroke para representar el porcentaje */
  dashOffset(pct: number): number {
    const clamped = Math.min(Math.max(pct, 0), 100);
    return +(CIRC * (1 - clamped / 100)).toFixed(2);
  }

  /** Color semáforo según % */
  ringColor(pct: number): string {
    const t = this.themeSvc.current;
    if (pct >= 100) return t.success;
    if (pct >= 80)  return t.warning;
    return t.danger;
  }

  /** Glow del anillo */
  ringGlow(pct: number): string {
    return `0 0 10px ${this.ringColor(pct)}66`;
  }

  /** Texto del porcentaje formateado */
  pctLabel(pct: number): string {
    return pct >= 100 ? '✓' : `${Math.round(pct)}%`;
  }
}
